import { createMapLibreMapAdapter } from '../engines/maplibre/adapter.ts';
import { getMapLibreVersion } from '../engines/maplibre/runtime.ts';
import { createBrowserCameraNavigation } from '../app/browser-camera-navigation.ts';
import { createBrowserTrailSelectionUrlState } from '../app/browser-trail-selection.ts';
import {
  createBrowserAnalytics,
  productionAnalyticsConfiguration,
  startAnalytics,
} from '../app/analytics.ts';
import { bootstrap } from './bootstrap.tsx';
import { loadMapLibreMountOptions } from './map-content.ts';

startAnalytics(createBrowserAnalytics(window), productionAnalyticsConfiguration);
void loadMapLibreMountOptions()
  .then((map) => {
    bootstrap({
      engine: 'maplibre',
      engineVersion: getMapLibreVersion(),
      application: {
        adapter: createMapLibreMapAdapter(),
        cameraNavigation: createBrowserCameraNavigation(window),
        trailSelectionUrlState: createBrowserTrailSelectionUrlState(window),
        map,
      },
    });
  })
  .catch(() => {
    bootstrap({
      engine: 'maplibre',
      engineVersion: getMapLibreVersion(),
      application: { startupFailure: true },
    });
  });
